import React, { useEffect, useRef } from "react";
import { Outlet, useParams } from 'react-router-dom';
import { ProfHeader } from "./profHeader";
import './profile.css';
import { useSelector, useDispatch } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../firebase/firebase";
import { setUsers } from "../../app/appSlice";

export const Profile = () => {
  const { users, stories, activity, following, isLoading, error, user } = useSelector(state => state.app);
  const dispatch = useDispatch(); // Use dispatch to dispatch actions
  const { username } = useParams();
  const profile = users.find(user => user.username === username);
  
  const previousUsername = useRef(username); 
  const isInitialRender = useRef(true); // This ref will track if it's the first render

  useEffect(() => {
    if (previousUsername.current !== username || isInitialRender.current) {
      // Scroll to the top if the profile has changed or it's the initial render
      window.scrollTo(0, 0);
      isInitialRender.current = false;
    }
    previousUsername.current = username; // Update previous username for the next check

    // Fetch user from Firestore if it's not in the users list
    if (!profile) {
      const fetchUserProfile = async () => {
        try {
          const userRef = doc(firestore, "users", username);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = { id: userSnap.id, ...userSnap.data() };
            // Add user to users in state if not already there
            if (!users.some(user => user.id === userData.id)) {
              // Prevent multiple dispatches for the same user
              dispatch(setUsers({ data: [userData], lastDoc: null, replace: false }));
              console.log('dispatched setUsers')
            }
          }
        } catch (error) {
          console.error("Error fetching user profile:", error);
        }
      };
      fetchUserProfile();
    }
    // eslint-disable-next-line
  }, [username, profile, dispatch]);

  if(!profile){
    return(
      <div className="loading-screen">
        <img src="/images/brand/favlogotrans.png" alt="Loading..." className="loading-image" loading="lazy" />
      </div>
    )
  }

  return (
    <div className='page'>
      {users.length && (
        <div className='content' id='prof-page'>
          <ProfHeader
            user={user}
            users={users} 
            following={following} 
            profile={profile} 
            activity={activity}
          />        
          <Outlet context={{ user, users, stories, activity, following, isLoading, error, profile }} />
        </div>
      )}
    </div>
  );
};
